// agentLinkResolver — the shell's binding of the pure `resolveInlineLink` to the
// library index, plus the one impurity it owns: a DEV-only log, once per href,
// for every agent link that degrades to plain text (an id not in the library, an
// unsupported href). Never user-facing — the Author just sees the text.

export { agentLinkResolver };

import type { ResolveInlineLink } from "../../components/Chat/InlineLink/InlineLink.js";
import type {
    ResourceId,
    ResourceRef,
} from "../../components/Navigation/types.js";
import { resolveInlineLink } from "../route/resourceLink.js";

const loggedPlainHrefs = new Set<string>();

const agentLinkResolver = (
    refFor: (id: ResourceId) => ResourceRef | undefined,
): ResolveInlineLink => {
    const resolve = resolveInlineLink(refFor);
    return (href) => {
        const target = resolve(href);
        if (
            import.meta.env.DEV &&
            target.type === "plain" &&
            !loggedPlainHrefs.has(href)
        ) {
            loggedPlainHrefs.add(href);
            console.debug(
                `[chat] agent link rendered as plain text (${target.reason}): ${href}`,
            );
        }
        return target;
    };
};
